<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('recipients.details.list.anticipation.title') }}
        </h2>
      </div>
    </div>
    <div class="emd-card-grid">
      <div class="el-grid-list el-section _separator">
        <div class="el-bounds">
          <div class="demo-grid-item _separator">
            <label class="emd-text _type_caption">{{
              $t('recipients.details.list.anticipation.enabled')
            }}</label>
            <p
              class="emd-card-grid__line emd-text"
              style="font-weight: bold"
              v-bind:class="status"
            >
              {{ $t(automatic) }}
            </p>
          </div>
        </div>
        <template v-if="data && data.enabled">
          <div class="el-bounds">
            <div class="demo-grid-item">
              <label class="emd-text _type_caption">{{
                $t('recipients.details.list.anticipation.type')
              }}</label>
              <p class="emd-card-grid__line emd-text">{{ data.type_label }}</p>
            </div>
          </div>
          <div class="el-bounds">
            <div class="demo-grid-item">
              <label class="emd-text _type_caption">{{
                $t('recipients.details.list.anticipation.volume_percentage')
              }}</label>
              <p class="emd-card-grid__line emd-text">{{ percent }}</p>
            </div>
          </div>
          <div
            v-if="data.day_anticipation"
            class="el-bounds"
          >
            <div class="demo-grid-item">
              <label class="emd-text _type_caption">{{
                $t('recipients.details.list.anticipation.day')
              }}</label>
              <p class="emd-card-grid__line emd-text">
                {{ data.day_anticipation }}
              </p>
            </div>
          </div>
          <div class="el-bounds">
            <div class="demo-grid-item">
              <label class="emd-text _type_caption">{{
                $t('recipients.details.list.anticipation.delay')
              }}</label>
              <p class="emd-card-grid__line emd-text">{{ delay }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { statusClass } from '@/filters'
import { prepaymentType } from '@/filters/recipients'

export class AnticipationSettings {
  constructor (enabled, delay, type, volumePercentage, dayAnticipation) {
    this.enabled = enabled
    this.delay = delay
    this.type = type && prepaymentType(type)
    this.type_label = type
    this.volume_percentage = volumePercentage
    this.day_anticipation = dayAnticipation
  }
}

export default {
  name: 'RecipientAnticipationSettings',
  props: {
    data: new AnticipationSettings()
  },
  computed: {
    automatic () {
      return this.data.enabled
        ? 'recipients.details.list.transfer.type.enabled'
        : 'recipients.details.list.transfer.type.disabled'
    },
    status () {
      const status = this.data.enabled ? 'active' : 'canceled'
      return statusClass(status)
    },
    percent () {
      return this.data.volume_percentage + '%'
    },
    delay () {
      return this.data.delay + (this.data.delay > 1 ? ' dias' : ' dia')
    }
  }
}
</script>
